/* eslint-disable no-unused-vars */
import React, { useContext, useState } from "react";
import Logo from "../../assets/img/logo.svg";
import camera from "../../assets/images/icons/camera.svg";
import { Link, useNavigate } from "react-router-dom";
import { CelebRegistrationContext } from '../../context/CelebRegistrationContext';
import { register as authRegister } from '../../services/authService';
import { toast } from 'react-toastify';
import Navbar from "../../components/landingpage/sections/Navbar";

// Cloudinary configuration
const CLOUD_NAME = "dcyzivpw4";
const UPLOAD_PRESET = "howzitone";

const CelebRegisterStepOne = (props) => {
  const [profilePic, setProfilePic] = useState(null);
  const [preview, setPreview] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const context = useContext(CelebRegistrationContext);

  if (!context) {
    return <div>Loading registration data...</div>;
  }

  const { registrationData, clearRegistrationData } = context;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error('Please select an image file');
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image size should be less than 5MB');
        return;
      }

      setProfilePic(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const uploadImageToCloudinary = async (file) => {
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", UPLOAD_PRESET);
      formData.append("folder", "howzit/celeb-profiles");

      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || 'Upload failed');
      }

      if (data.secure_url) {
        return data.secure_url;
      } else {
        throw new Error('Upload failed: No URL returned');
      }
    } catch (error) {
      console.error("Cloudinary upload error:", error);
      throw new Error(error.message || 'Failed to upload image');
    } finally {
      setIsUploading(false);
    }
  };

  const handleCompleteRegistration = async () => {
    if (!profilePic) {
      toast.error('Please upload a profile picture');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const imageUrl = await uploadImageToCloudinary(profilePic);

      const finalData = {
        ...registrationData,
        profilepicture: imageUrl,
        userType: 'celeb'
      };

      const response = await authRegister(finalData);

      if (response.success) {
        toast.success('Registration successful! Please login with your email and password to receive OTP.');

        if (clearRegistrationData) {
          clearRegistrationData();
        }

        navigate('/celeb-email-login', {
          state: {
            preFilledEmail: finalData.email
          }
        });
      } else {
        setError(response.message || 'Registration failed');
        toast.error(response.message || 'Registration failed');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError(err.message || 'Registration failed');
      toast.error(err.message || 'Registration failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isProcessing = isSubmitting || isUploading;

  return (
    <>
      <Navbar {...props} />
      <div className="content login-page pt-0">
        <div className="container-fluid">
          <div className="account-content">
            <div className="row align-items-center">
              <div className="login-right">
                <div className="inner-right-login">
                  <div className="login-header">
                    <div className="logo-icon">
                      <img src={Logo} alt="" />
                    </div>

                    <div className="step-list">
                      <ul>
                        <li>
                          <Link to="/celeb-register" className="back-arrow">
                            <i className="fa-solid fa-arrow-left" />
                          </Link>
                        </li>
                        <li>
                          <Link to="/celeb-register" className="active-done">
                            1
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="active">
                            2
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {error && (
                      <div className="alert alert-danger mb-4">
                        <strong>Error!</strong> {error}
                      </div>
                    )}

                    <form id="profile_pic_form">
                      <div className="profile-pic-col">
                        <h3>Profile Picture</h3>
                        <div className="profile-pic-upload">
                          {preview ? (
                            <img
                              src={preview}
                              alt="Preview"
                              className="img-fluid rounded-circle"
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover'
                              }}
                            />
                          ) : (
                            <div className="cam-col">
                              <img src={camera} alt="" className="img-fluid" />
                            </div>
                          )}
                          <span>Upload Profile Picture</span>
                          <input
                            type="file"
                            id="profile_image"
                            name="profile_image"
                            onChange={handleFileChange}
                            accept="image/*"
                            disabled={isProcessing}
                          />
                        </div>
                        <div className="upload-info mt-2">
                          <small className="text-muted">
                            Supported formats: JPG, PNG, SVG. Max size: 5MB
                          </small>
                        </div>
                      </div>
                      <div className="mt-5">
                        <button
                          type="button"
                          className="btn btn-primary w-100 btn-lg login-btn"
                          onClick={handleCompleteRegistration}
                          disabled={isProcessing || !profilePic}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              {isUploading ? 'Uploading Image...' : 'Completing Registration...'}
                            </>
                          ) : (
                            'Complete Registration'
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="login-bottom-copyright">
                  <span>© 2025 howzit!. All rights reserved.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CelebRegisterStepOne;